import type { StyleRule } from '@archipro-design/aria';
import {
    boxClassName,
    captionClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const CompanyInfoContainer: StyleRule = () => ({
    marginRight: pxToRem(-1),
    marginTop: pxToRem(1),
});

export const CompanyInfoList: StyleRule = ({ theme }) => ({
    width: pxToRem(896),
    borderTop: `1px solid ${theme.siteVariables.colors.primitive.black}`,
    marginTop: pxToRem(-2),
    display: 'block',
    '& > [role=listitem]': {
        display: 'flex',
        alignItems: 'center',
        height: pxToRem(56),
        borderColor: theme.siteVariables.colors.primitive.black,
        marginBottom: 0,
        '&:last-child': {
            [`& .${captionClassName}`]: {
                padding: pxArrayToRem([1, 0, 0, 0]),
            },
        },
        [`& .${captionClassName}`]: {
            fontSize: pxToRem(16),
            letterSpacing: theme.siteVariables.letterSpacingNormal,
            width: pxToRem(372),
            paddingBottom: pxToRem(2),
        },
        '& > div': {
            display: 'flex',
            alignItems: 'center',
            fontSize: pxToRem(16),
            letterSpacing: theme.siteVariables.letterSpacingNormal,
            lineHeight: '100%',
            color: '#151416', // Replace with theme variable once available
        },
    },
});

export const WebsiteStat: StyleRule = ({ theme }) => ({
    width: '100%',
    '& > a': {
        color: theme.siteVariables.colorScheme.default?.foreground2,
        textDecorationThickness: '1px !important',
        textUnderlineOffset: '3px !important',
        fontWeight: 500,
        '&:hover': {
            textDecoration: 'none',
        },
    },
});

export const ProfileButton: StyleRule = ({ theme }) => ({
    height: pxToRem(56),
    marginRight: `0 !important`,
    padding: `${pxToRem(25)} !important`,
    outline: 'transparent',

    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colors.white['000'],
        textTransform: 'uppercase !important',
        fontSize: theme.siteVariables.fontSizes.label01,
        lineHeight: theme.siteVariables.lineHeightSmallest,
        letterSpacing: theme.siteVariables.letterSpacingMedium,
    },
});

export const LikeButtonContainer: StyleRule = () => ({
    position: 'relative',
    marginLeft: pxToRem(21),
    top: pxToRem(1),
    right: pxToRem(14),
    borderRadius: '50%',
    '&:hover': {
        background: 'rgba(0, 0, 0, 0.06)',
    },
    padding: 0,
});

export const HeartButton: StyleRule = () => ({
    borderRadius: '0',
    margin: 0,
    height: pxToRem(56),
});

export const ReviewsStarContainer: StyleRule = () => ({
    marginLeft: pxToRem(-3),
    gap: pxToRem(5),
});

export const StarIcon: StyleRule = () => ({
    height: `${pxToRem(26)} !important`, // override aria
    width: `${pxToRem(26)} !important`, // override aria
    '> svg': {
        height: '100%',
        width: '100%',
    },
});

export const ReviewsCount: StyleRule = ({ theme }) => ({
    minWidth: pxToRem(120),
    marginLeft: pxToRem(18),
    fontSize: `${pxToRem(24)} !important`,
    textDecoration: 'underline',
    textDecorationSkipInk: 'none',
    letterSpacing: `${theme.siteVariables.letterSpacingMedium} !important`, // override :(
});

export const FavouriteGroup: StyleRule = () => ({
    ['& .' + boxClassName]: {
        marginRight: '0',
        '&:not(:last-child)': {
            marginRight: '0',
        },
    },
});

export const UsuallyRespondsWithin: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(30),
    paddingBottom: pxToRem(20),
    fontSize: pxToRem(22),
    fontWeight: '400',
    letterSpacing: theme.siteVariables.letterSpacingMedium,
    lineHeight: theme.siteVariables.lineHeightSmallest,
    color: theme.siteVariables.colors.charcoal[250],
    textTransform: 'uppercase',
});
